import * as Common from '../Common/commonConstants';

// Necessary endpoints
export const ENDPOINT_CALCULARRESULTADOSIMULACAO = Common.API_BASE_URL+'/api/Estimativa/CalcularResultadoSimulacao';
export const ENDPOINT_CALCULARRESULTADOPORTUARIOSIMULACAO = Common.API_BASE_URL+'/api/Estimativa/CalcularResultadoSimulacaoPortuaria';
export const ENDPOINT_GERARRELATORIOFINAL = Common.API_BASE_URL+'/api/Estimativa/GerarRelatorioFinal';
export const ENDPOINT_GERARRELATORIOFINALPORTUARIO = Common.API_BASE_URL+'/api/Estimativa/GerarRelatorioFinalPortuario';